
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { BoxStatusType } from '@/types';

@Component
export default class BoxStatus extends Vue {
  @Prop(String) readonly value!: BoxStatusType | null;

  @Prop({ type: Boolean, default: false }) readonly readonly!: boolean;
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: String, default: 'success' }) readonly doneColor!: string;
  @Prop({ type: String, default: 'grey' }) readonly todoColor!: string;
  @Prop({ type: Boolean, default: false }) readonly doneDisabled!: boolean;

  boxStatus: BoxStatusType = 'todo';

  updateTimeout: number | undefined;

  created() {
    console.log('BoxStatus: created()'); // eslint-disable-line no-console

    if (this.value === null) {
      this.boxStatus = 'todo';
    } else {
      this.boxStatus = this.value;
    }
  }

  @Watch('value')
  onValue(val: BoxStatusType) {
    console.log('BoxStatus: onValue()'); // eslint-disable-line no-console

    this.boxStatus = val;
  }

  @Watch('doneDisabled')
  onDoneDisabled(val: boolean, oldVal: boolean) {
    console.log(`${this.constructor.name}: onDoneDisabled() ${oldVal} => ${val}`); // eslint-disable-line no-console

    // Se lo stato attuale è 'done'...
    if (this.boxStatus === 'done') {
      // ... se siamo passati da doneDisabled = false a doneDisabled = true...
      if (oldVal === false && val === true) {
        // ... si prepara ad aggiornare da 'done' a 'todo'
        this.handleUpdate();
      } else

      // ... se invece siamo passati da doneDisabled = true a doneDisabled = false...
      if (oldVal === true && val === false) {
        // ... ferma eventuali aggiornamenti da 'done' a 'todo'
        if (this.updateTimeout) clearTimeout(this.updateTimeout);
      }
    }
  }

  handleUpdate() {
    console.log(`${this.constructor.name}: handleUpdate()`); // eslint-disable-line no-console

    if (this.updateTimeout) clearTimeout(this.updateTimeout);

    this.updateTimeout = setTimeout(() => {
      console.log(`${this.constructor.name}: handleUpdate() timeout!`); // eslint-disable-line no-console

      this.boxStatus = 'todo';
      this.$emit('input', 'todo');
    }, 0); // Debouncing disattivato
  }

  get boxColor(): string {
    switch (this.boxStatus) {
      case 'todo':
        return this.todoColor;

      case 'done':
        return this.doneColor;

      case 'waiting':
        return 'orange';

      case 'na':
        return 'grey';

      default:
        break;
    }

    return '';
  }

  get boxDark(): boolean {
    // if (this.disabled) return false;

    switch (this.boxStatus) {
      case 'todo':
        return true;

      case 'done':
        return true;

      case 'waiting':
        return true;

      case 'na':
        return false;

      default:
        break;
    }

    return true;
  }

  get boxOutlined(): boolean {
    switch (this.boxStatus) {
      case 'todo':
      case 'done':
      case 'waiting':
        return false;

      case 'na':
        return true;

      default:
        break;
    }

    return false;
  }

  get boxText(): string {
    switch (this.boxStatus) {
      case 'todo':
        return 'Da fare';

      case 'done':
        return 'Fatto';

      case 'waiting':
        return 'In attesa';

      case 'na':
        return 'Non applicabile';

      default:
        break;
    }

    return 'Non disponibile';
  }

  async setBoxStatus(status: BoxStatusType) {
    if (this.boxStatus === status) {
      console.log(`BoxStatus: setBoxStatus() status = ${status} (non modificato, ignorato)`); // eslint-disable-line no-console
      return;
    }

    console.log('BoxStatus: setBoxStatus() status =', status); // eslint-disable-line no-console

    this.boxStatus = status;

    this.$emit('input', status);
  }
}
